import { Col, Row, Form } from "antd";
import React from "react";
import Inputs from "../../../../biblio/Inputs/Inputs";
import Selects from "../../../../biblio/Selects/Selects";
import UploadInput from "../../../../biblio/Inputs/UploadInput";
import { UploadOutlined } from "@ant-design/icons";
import { convertFileToBase64 } from "../../../../components/utils/utils";

interface BankInfoProps {
  banks: any;
  form: any;
}

const BankInfo = ({ banks, form }: BankInfoProps) => {
  // Handle file change and convert to Base64
  const handleFileChange = async (fileList: any[]) => {
    const file = fileList[0]?.originFileObj;

    if (file) {
      try {
        const base64 = await convertFileToBase64(file);
        const imageData = {
          filename: file.name,
          data: base64,
        };

        form.setFieldsValue({
          widow_iban_image_ids: [imageData],
        });
      } catch (error) {
        console.error("Error converting file to Base64:", error);
      }
    }
  };
  return (
    <>
      <div className="takaful--title-tabs-sub">
        <span>معلومات عن الحساب</span>
      </div>
      <Row gutter={16}>
        <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
          <Form.Item
            name="account_number"
            label="رقم الحساب"
            className="takaful--label-inputs"
            labelCol={{ className: "takaful--label-style" }}
            rules={[
              {
                required: true,
                message: "الرجاء تعبئة الحقل",
              },
            ]}
          >
            <Inputs type="tel" />
          </Form.Item>
        </Col>

        <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
          <Form.Item
            name="bank_id"
            label="البنك"
            labelCol={{ className: "takaful--label-style" }}
            rules={[
              {
                required: true,
                message: "الرجاء تعبئة الحقل",
              },
            ]}
          >
            <Selects options={banks} />
          </Form.Item>
        </Col>

        <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
          <Form.Item
            name="account_owner"
            label="صاحب الحساب"
            className="takaful--label-inputs"
            labelCol={{ className: "takaful--label-style" }}
            rules={[
              {
                required: true,
                message: "الرجاء تعبئة الحقل",
              },
            ]}
          >
            <Inputs type="text" />
          </Form.Item>
        </Col>

        <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
          <Form.Item
            name="widow_iban_image_ids"
            label="صورة رقم الايبان للأرملة"
            labelCol={{ className: "takaful--label-style" }}
            rules={[
              {
                required: true,
                message: "الرجاء تعبئة الحقل",
              },
            ]}
          >
            <UploadInput
              accept="image/*"
              text="صورة رقم الايبان للأرملة"
              icon={<UploadOutlined />}
              multiple={false}
              maxCount={1}
              onChange={handleFileChange}
            />
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};

export default BankInfo;
